// extracted by mini-css-extract-plugin
export default {"buttonPadding":"style_buttonPadding__IJLLt","quit":"style_quit__1mjjn"};